import { render, staticRenderFns } from "./TranslatorPayments.vue?vue&type=template&id=6efbbfa8&"
import script from "./TranslatorPayments.vue?vue&type=script&lang=js&"
export * from "./TranslatorPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports